import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

/**
 * Init Carousel.
 * @param {HTMLElement} rootElement - The root element.
 * @return {void}
 */
function initBookCarousel( rootElement ) {
	const swiper = new Swiper( rootElement, {
		enabled: false,
		createElements: true,
		modules: [ Pagination, Navigation ],
		slidesPerView: 1,
		slideClass: 'rte-book-carousel--slide',
		simulateTouch: false,
		spaceBetween: 32,
		loop: true,
		wrapperClass: 'rte-book-carousel--wrapper',
		slidesOffsetAfter: 4,
		navigation: {
			enabled: true,
			prevEl: '.swiper-button-prev',
			nextEl: '.swiper-button-next',
		},
		pagination: {
			el: '.swiper-pagination',
			type: 'bullets',
			clickable: true,
		},
		breakpoints: {
			1024: {
				navigation: { enabled: true },
				slidesPerView: 1,
				spaceBetween: 32,
				slidesOffsetAfter: 0,
			},
			1280: {
				navigation: { enabled: true },
				slidesPerView: 1,
				spaceBetween: 32,
				slidesOffsetAfter: 0,
			},
			1536: {
				navigation: { enabled: true },
				spaceBetween: 32,
				slidesPerView: 1,
				slidesOffsetAfter: 0,
			},
		},
	} );

	if ( rootElement.classList.contains( 'rte-book-carousel' ) ) {
		swiper.enable();
	}
}

export default initBookCarousel;
